// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_1a-1";
export var movingGradient = "_1a-4";
export var movingGradientBlock = "_1a-2";
export var skeleton = "_1a-0";
export var skeletonText = "_1a-3";